export const BCColorArray: string[] = [
  "#01b8aa",
  "#28383c",
  "#fd625e",
  "#f2c80f",
  "#5f6b6d",
  "#8ad4eb"
];